import {
  TAGS_CHANGE,
  LOAD_TAGS_START,
  LOAD_TAGS_SUCCESS,
  LOAD_TAGS_FAILURE,
} from '../actions/tagsAction'

const initialState = {
  tags: [],

  tagsLoading: true,
  tagsError: '',
}

const reducer = (state = initialState, action) => {
  const { type, payload } = action

  switch (type) {
    case TAGS_CHANGE: {
      const newState = { ...state }
      if (payload.tags) {
        newState.tags = payload.tags
      }
      return newState
    }
    case LOAD_TAGS_START: {
      return {
        ...state,
        tagsLoading: true,
        tagsError: ''
      }
    }
    case LOAD_TAGS_SUCCESS: {
      const newState = {
        ...state,
        tagsLoading: false,
        tagsError: ''
      }
      if (payload.tags) {
        newState.tags = payload.tags
      }
      return newState
    }
    case LOAD_TAGS_FAILURE: {
      return {
        ...state,
        tagsLoading: false,
        tagsError: payload.error
      }
    }
    default: {
      return state
    }
  }
}

export default reducer
